import { Component, OnInit } from '@angular/core';
import { UserManagementService } from '../../../service/user-management.service';
import { SupplierManagementService } from '../../../service/supplier-management.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Message } from 'primeng/components/common/api';

@Component({
    selector: 'suppliers-list', 
    templateUrl: './suppliers-list.component.html',
    styleUrls: ['./suppliers-list.component.css']
})
export class SuppliersListComponent implements OnInit {

  search: string = "";
  resultTable: any[] = null;
  cols: any[];
  message: string = '';
  msgs: Message[] = [];

  constructor(private dataService: UserManagementService, private supplierService: SupplierManagementService, private router: Router) {}

  ngOnInit() {
    this.cols = [
      { field: 'Id', header: 'מזהה ספק' },
      { field: 'SupplierName', header: 'שם ספק' },
      { field: 'SupplierNum', header: 'מספר ספק' },
      { field: 'EMail', header: 'כתובת מייל' },
      { field: 'Phone1', header: 'טלפון' },
      { field: 'Phone2', header: 'טלפון נוסף' },
      { field: 'Address', header: 'כתובת' },
      { field: 'Active', header: 'פעיל' },
      { field: 'Notes', header: 'הערות' },
      { field: 'SupplierInternalNum', header: 'מספר ספק פנימי' }
    ];

    this.getSuppliers();
  }

  getSuppliers(): void {
    
      this.supplierService.getSuppliers().subscribe((result: any) => {
        this.resultTable = result;
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה באחזור הודעה');
        });
  }

  editSupplier(id) {
    this.router.navigate(['supplier-edit/', id])
  }



  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }

  showErrorSpecific() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' תקלה בהורדת קובץ' });
  }

}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/supplier-management/suppliers/suppliers-list/suppliers-list.component.ts